export default __webpack_public_path__ + "media/4e2d2af66d65636d0935d44dd6fbf60e953e97a173f0b5dc033b153efc7f5d2b.svg";